/**
 * All Printers Page (Settings → Printer Settings)
 * Lists, adds and tests the selected outlet's printers.
 */

import { useAppSelector } from '@hooks/useRedux';
import { selectEffectiveOutletId } from '@store/outlets';
import React from 'react';
import { PrintersTab } from './PrintersTab';

export const AllPrintersPage: React.FC = () => {
  const outletId = useAppSelector(selectEffectiveOutletId);

  if (!outletId) {
    return (
      <div className="rounded-2xl border border-gray-200 bg-white p-8 text-sm text-gray-600">
        Select a specific outlet to manage its printers.
      </div>
    );
  }

  return <PrintersTab />;
};
